import { Slider, Range } from './styles'

Slider.Range = Range

export default Slider
